import React, {useEffect, useMemo, useState} from "react";
import Search from "../../../../components/search/Search";
import {SearchComboBox} from "../../../../components/select/SearchComboBox";
import SearchSection from "../../../../components/search/SearchSection";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import {getIndividualSetting} from "../../../../api/user/UserAccountService";
import {
    extractObject,
    initHeaderOrders,
    nonObject,
    simmsColumnsToJsGridHeaders
} from "../../../../components/commonmethod/CommonMethod";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import SimmsJsGrid from "../../../../components/js-grid/SimmsJsGrid";
import {useExcelDownloadClick} from "../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../components/js-grid/JsGridExcelGridOpenButton";
import HistoryLinkedListView from "../components/HistoryLinkedListView";

const listType = [
    {id: 'C', name: "등록"},
    {id: 'U', name: "수정"},
    {id: 'D', name: "삭제"}
];

function HistoryListType({data, date, pageInfo, header, type, menu, dataHook, linkedLayout = false}) {
    ///** 심스테이블추가
    const [tableHeader, setTableHeader] = useState({order:header, exclude:[]});
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const [exclude, setExclude] = useState([]);
    const [pin, setPin] = useState();
    //**

    const searchDate = {startDate: saveConditions.startDate?? date.startDate ,endDate: saveConditions.endDate?? date.endDate }

    useEffect(()=>{
        ///** 심스테이블추가
        getIndividualSetting().then(r=>{
            initHeaderOrders(r, header, setTableHeader, exclude, setExclude, setPin,type);
        })
        //**

    },[])

    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const convertedHeader = useMemo(() => simmsColumnsToJsGridHeaders(tableHeader), [tableHeader]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    const searchBlock = (
        <Search
            entity={type}
            refresh={refresh}
            handleSearch={handleSearch}
            searchConditions={saveConditions}
            handlePageSizeChange={handlePageSizeChange}
            pageInfo={pageInfo}
            size
            date={searchDate}
            detail
            searchBar={{placeHolder: "필드명, 수정전, 수정후"}}
        >
            <SearchSection>
                <SearchComboBox
                    title={"타입"}
                    code={listType}
                    target={"historyType"}
                    value={saveConditions}
                    onChange={(v) => nonObject(saveConditions, v, handleSearch, "historyType")}
                />
                <Selector
                    showLabel
                    onChange={(value) => searchListener(handleSearch, "user", extractObject(saveConditions), value)}
                    data={saveConditions.user}
                    uniqueKey={"user"}
                    entity={"userAccount"}
                    title={"수정자"}
                >
                    <SimmsInputSearch type={"TEXT"} placeHolder={"사용자명"} />
                    <SimmsDrawerSearch showLabel title={"부서"} entity={"department"} target={"department"} recursive />
                    <SimmsDrawerSearch showLabel title={"업체"} entity={"company"} target={"company"} />
                </Selector>

                {menu && (
                    <SearchComboBox
                        title={"메뉴"}
                        code={menu}
                        target={"entityName"}
                        search
                        value={saveConditions}
                        onChange={(v) => nonObject(saveConditions, v, handleSearch, "entityName")}
                    />
                )}
            </SearchSection>
        </Search>
    );

    if (linkedLayout) {
        return (
            <HistoryLinkedListView
                headerDefinition={tableHeader.order ?? header}
                settingKey={type}
                newData={data}
                onPageChange={handleGridPageChange}
            >
                {searchBlock}
            </HistoryLinkedListView>
        );
    }

    return (
        <div className="container-height">
            {searchBlock}
            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={"linear"}
                    style={{minHeight: 0, height: "100%"}}
                    header={convertedHeader}
                    onHeaderSave={() => console.log("headerSave")}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="History" search={excelGridSearch} />
                        </div>
                    )}
                />
            </div>
        </div>
    );
}
export default HistoryListType;
